import './Header.scss';

import Button from '../../../../components/ui/Button';
import appImg from '../../../../assets/images/download-app.png';

const Header = ({ image, title, buttons }) => {
    let headerStyle = {
        backgroundImage: `linear-gradient(#000 0%, #0000 83.44%), url(${image})`,
    };

    return (
        <header className="Header__download" style={headerStyle}>
            <div className="container text--center">
                <h1 className="heading heading--large heading--white">
                    {title}
                </h1>

                <h2 className="heading heading--extra-small heading--white mt2">
                    Download de ESPN app
                </h2>

                {buttons && (
                    <div className="buttons mt3 pb3">
                        {buttons.map(button => {
                            return (
                                <Button
                                    label={button.label}
                                    link={button.link}
                                    track={button.track}
                                />
                            );
                        })}
                    </div>
                )}

                <div className="Header__content container text--left">
                    <div className="row">
                        <div className="col">
                            <h2 className="heading heading--medium">
                                Live wedstrijden
                                <br />
                                kijken
                            </h2>
                            <p className="text">
                                Stream live wedstrijden, kijk je favoriete
                                programma’s en ontdek de mooiste
                                sportdocumentaires waar en wanneer je wilt.
                                Beschikbaar voor smartphone, tablet, Apple TV,
                                Chromecast en Apple Watch. Wedstrijd gemist?
                                Bekijk alle goals en samenvattingen van jouw
                                club direct na afloop.
                            </p>
                        </div>
                        <div className="col">
                            <img src={appImg} alt="ESPN app on phone" />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
